
export const GET_ALL_PRODUCTS_RESULT = 'GET_ALL_PRODUCTS_RESULT';
export const GET_ALL_PRODUCTS = 'GET_ALL_PRODUCTS';

//Paquetes NPM de GYF. 
import { Mediator } from 'com-gyf-webcore-mediator';
//import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, ConciergeProxy, SagasProxy } from 'com-gyf-webcore-servicehub';

//Import del reducer de DistribucionLimites.
import NuevaSolicitud from '../../../store/Reducers/NuevaSolicitud';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

//Entidades...
import Cliente from '../components/Cliente'

export const GET_EXISTE_SOLICITUD_COMPLETED = 'GET_EXISTE_SOLICITUD_COMPLETED';
export const SET_FUNCIONES_DE_USUARIO = 'SET_FUNCIONES_DE_USUARIO';
export const GET_SCREEN_DATA = 'GET_SCREEN_DATA';
export const CARGAR_TARJETAS_BY_CUENTA = 'CARGAR_TARJETAS_BY_CUENTA';
export const WEBSERVICE_RESULT = 'WEBSERVICE_RESULT';
export const BORRAR_SOLICITUD_PENDIENTE_CUENTAS = 'BORRAR_SOLICITUD_PENDIENTE_CUENTAS';
export const ALERTA_PROCESO_FINALIZADO_CORRECTAMENTE = 'ALERTA_PROCESO_FINALIZADO_CORRECTAMENTE';
export const AGREGAR_QUITAR_CUENTA_VINCULADA = 'AGREGAR_QUITAR_CUENTA_VINCULADA';
export const CAMBIAR_CUENTA_PRINCIPAL = 'CAMBIAR_CUENTA_PRINCIPAL';
export const VINCULOSS_BY_NUMERO_CUENTA = 'VINCULOSS_BY_NUMERO_CUENTA';
export const MOSTRAR_VINCULOS = 'MOSTRAR_VINCULOS';
export const HISTORIAL_MOVIMIENTOS_TARJETA = 'HISTORIAL_MOVIMIENTOS_TARJETA'
export const GET_SOLICITUDES_PLASTICO_BY_PLASTICO_ID = 'GET_SOLICITUDES_PLASTICO_BY_PLASTICO_ID';
export const OBTENER_DOMICILIOS_SELECCIONAR_CUENTA = 'OBTENER_DOMICILIOS_SELECCIONAR_CUENTA';
export const SET_CUENTA_DELIVERY = 'SET_CUENTA_DELIVERY';
export const GET_VINCULACIONES = 'GET_VINCULACIONES';
export const ERROR_VINCULACION = 'ERROR_VINCULACION';
export const BORRAR_VINCULO = 'BORRAR_VINCULO';
export const MOSTRAR_OCULTAL_MODAL_VINCULOS = 'MOSTRAR_OCULTAL_MODAL_VINCULOS';
export const CERRAR_MENSAJE_ALERTA_VINCULACIOn = 'MOSTRAR_OCULTAL_MODAL_VINCULOS';

RestApiProxy.SetApiUrl();

let _cuentas;
let _dispatch;
let _idSolicitud;
let _cliente;
let _userId;
let _login;
let userFeatures = [];
let userFunctions = [];
let _nroTarjeta;

/** 
 * Obtiene el estado inicial de la pantalla.
 */
export function getScreenData(state, currentScope, cuentas, tarjetas, cliente, login) {

    //LogHelper.In(getScreenData.name, state, currentScope, cuentas);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        _cuentas = cuentas;
        _cliente = cliente;
        _login = login;
        _userId = currentScope.UserId;

        dispatch({ type: GET_SCREEN_DATA, state, cuentas: cuentas, tarjetas: tarjetas });

        Mediator.SetCallbackFunction(_loadFuncionesUsuario);
        Mediator.SetEngine1Proxy(Engine1Proxy);

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _loadFuncionesUsuario(data), null, "GETFUNCTIONS", currentScopeRequest, null, "DELIVERY");
    }
    //LogHelper.Out(getScreenData.name, state, currentScope, cuentas);
}

/**
 * Permite obtener los vinculos entre cuentas que contengas a un plastico determinado.
 * @param {any} nrotarjeta
 */
export function GetVinculosByNroTarjeta(nrotarjeta) {
    //LogHelper.In(GetVinculosByNroTarjeta.name, cuentaId);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        _nroTarjeta = nrotarjeta;

        dispatch({ type: CERRAR_MENSAJE_ALERTA_VINCULACIOn });

        let parameters = {
            "NUMERO_TARJETA": nrotarjeta
        };

        Engine1Proxy.AddDataSourcesRequests(parameters, 'GET_VINCULOS_CUENTA_BY_NRO_TARJETA', 'Get', 'Tarjetas', 'Delivery', 1, 'Product');
        Engine1Proxy.Execute(_getVinculosByNroTarjetaResult, null, null, "DELIVERY");
    }
    //LogHelper.Out(GetVinculosByNroTarjeta.name, cuentaId);
}

/**
 * Permite crear o deshacer los vinculos entre las cuentas.
 * @param {any} cuentaId
 * @param {any} seleccionoTodo
 */
export function agregarQuitarCuentaVinculo(cuentaId, seleccionoTodo, cuentasDelivery) {
    //LogHelper.In(agregarQuitarCuentaVinculo.name, cuentaId);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({ type: AGREGAR_QUITAR_CUENTA_VINCULADA, cuentaId: cuentaId, cuentas: cuentasDelivery, seleccionoTodo: seleccionoTodo });
    }

    //LogHelper.Out(agregarQuitarCuentaVinculo.name, cuentaId);
}

/**
 * Permite seleccionar una cuenta principal de un conjunto mayor de dos cuentas.
 * @param {any} cuentaCodigo
 */
export function cambiarCuentaPrincipal(cuentaCodigo) {
    //LogHelper.In(cambiarCuentaPrincipal.name, cuentaId);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({ type: CAMBIAR_CUENTA_PRINCIPAL, cuentaCodigo: cuentaCodigo.target.value });
    }

    //LogHelper.Out(cambiarCuentaPrincipal.name, cuentaId);
}

/**
 * Permite el grabado de la vinculaci�n establecida entre n cuentas.
 * @param {any} cuentasIds
 * @param {any} tarjetaId
 * @param {any} cuentaPrincipal
 */
export function grabarVinculacion(cuentasIds, tarjetaId, cuentaPrincipal, estadoPlastico) {
    //LogHelper.In(grabarVinculacion.name, cuentaId);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        let cuentas = getState().tarjetas.cuentasDelivery;
        let infoCuentas = [];
        let _cuentaPrincipal = 0;
        let arrayCuentas = "";
        let cuentaTitular = undefined;

        let cantidadChecked = 0;
        for (var i = 0; i < cuentasIds.length; i++) {
            if (cuentasIds[i].checked)
                cantidadChecked++;
        }

        if (cantidadChecked == 1)
            cuentaPrincipal = -1

        //Valida que tenga una cuenta seleccionada.
        if ((cuentaPrincipal == -1 && cantidadChecked == 1) || (cuentaPrincipal > -1 && cantidadChecked > 1)) {

            let puedeGrabar = false;
            for (var i = 0; i < cuentasIds.length; i++) {
                if (cuentasIds[i].checked)
                    puedeGrabar = true;

                if (cuentasIds[i].FromDB && cuentasIds[i].checked !== cuentasIds[i].checkOriginal)
                    puedeGrabar = true;
            }

            //let contador = 0;
            //let noHayCambios = false;
            //for (var i = 0; i < cuentasIds.length; i++) {
            //    if ((cuentasIds[i].FromDB && cuentasIds[i].checked == cuentasIds[i].checkOriginal) || (cuentasIds[i].borrado && !cuentasIds[i].checked && !cuentasIds[i].hasOwnProperty('vinculoBorrado')) || (cuentasIds[i].vinculoBorrado && cuentasIds[i].checked))
            //        contador++;
            //}
            //if (contador == cuentasIds.length)
            //    noHayCambios = true;

            if (cuentaPrincipal == -1 && cantidadChecked == 1) {
                let cuentaUnica = cuentasIds.find(x => x.checked);
                cuentaPrincipal = cuentaUnica.numero;
            }


            if (puedeGrabar) {
                if (1 == 1) {
                    for (var i = 0; i < cuentasIds.length; i++) {

                        let c = {
                            NUMERO_TARJETA: tarjetaId,
                            NUMERO_CUENTA: cuentasIds[i].numero,
                            ACCION: cuentasIds[i].checked ? 'N' : 'D'
                        };

                        if (cuentasIds[i].checked && cuentasIds[i].numero !== cuentaPrincipal) {
                            arrayCuentas += cuentasIds[i].checked ? "," + cuentasIds[i].numero : '';
                        }

                        //Busca cual va a ser la cuenta principal de la pila...
                        if (cuentaPrincipal == cuentasIds[i].numero) {
                            c.PRINCIPAL = 1;
                            arrayCuentas += cuentasIds[i].checked ? "," + cuentasIds[i].numero : '';
                            cuentaTitular = cuentas.find(x => x.CodigoCuenta == cuentaPrincipal);
                        } else if (cuentaPrincipal == 0) {
                            c.PRINCIPAL = cuentasIds[i].checked ? 1 : 0;
                            arrayCuentas += cuentasIds[i].checked ? "," + cuentasIds[i].numero : '';
                            cuentaTitular = cuentas.find(x => x.CodigoCuenta == cuentasIds[i].numero);
                        } else {
                            c.PRINCIPAL = 0;
                            cuentaTitular = cuentas.find(x => x.CodigoCuenta == cuentaPrincipal);
                        }

                        //Valdia que la cuenta a vincular, si llega a venir de la BBDD sea distinta al estado original...
                        if (!(cuentasIds[i].hasOwnProperty('FromDB') && cuentasIds[i].FromDB && cuentasIds[i].checked === cuentasIds[i].checkOriginal)) {
                            infoCuentas.push(c);
                        }
                    }

                    let parameters = {
                        "infoCuentas": infoCuentas
                    };

                    //Valida que se este creando una nueva vinculacion para continuar...
                    if (parameters.infoCuentas.length > 0) {
                        arrayCuentas = arrayCuentas.substr(1)
                        let parametersSolicitud = _getLocalValuSolicitud(estadoPlastico);
                        parametersSolicitud.CUENTAS = arrayCuentas
                        if (cuentaTitular !== undefined)
                            if (cuentaTitular.Vinculo == 1)
                                parametersSolicitud.CODIGO_TRANSACCION = '130001';
                            else
                                parametersSolicitud.CODIGO_TRANSACCION = '130002';

                        let plastico = estadoPlastico.tarjetas.find(x => x.Numero == tarjetaId)

                        parametersSolicitud.CODIGO_SISTEMA = parseInt(cuentaTitular.CodigoSistema);
                        parametersSolicitud.CODIGO_MONEDA = parseInt(cuentaTitular.CodigoMoneda);
                        parametersSolicitud.SUCURSAL_ID = parseInt(cuentaTitular.Sucursal);
                        parametersSolicitud.NUMERO_TARJETA = tarjetaId;
                        parametersSolicitud.NUMERO_CUENTA = plastico.NumeroCuenta;
                        parametersSolicitud.PRODUCTO = plastico.idProducto;
                        parametersSolicitud.VINCULO_ORIGINAL = cuentaTitular.Vinculo

                        Engine1Proxy.AddRuleRequests(parametersSolicitud, 'CrearSolicitudVinculoCuentas', 'Tarjetas', 'Delivery');
                        Engine1Proxy.Execute(_guardarSolicitudVinculacionCallback, null, parameters, "DELIVERY");
                    }
                } else {
                    dispatch({ type: ERROR_VINCULACION, esError: 2 });
                }
            } else {
                dispatch({ type: ERROR_VINCULACION, esError: 1 });
            }
        } else {
            dispatch({ type: ERROR_VINCULACION, esError: 2 });
        }

        //LogHelper.Out(grabarVinculacion.name, cuentaId);
    }
}

/**
 * Da de baja la o las tarjetas seleccionadas.
 * @param {any} estadoPlastico
 * @param {any} tarjetaActual
 * @param {any} tipoBorrado
 */
export function borrarTarjeta(estadoPlastico, tarjetaActual, tipoBorrado, nroCuenta) {

    //LogHelper.In(borrarTarjeta.name, estadoPlastico, tarjetaActual, tipoBorrado);
    return (dispatch, getState) => {
        _dispatch = dispatch;
        if (tarjetaActual.numeroDocumento == ValueCuil(estadoPlastico.clienteResultadoBusqueda.NumeroDocumento.toString())) {
            var c = estadoPlastico.cuentasDelivery.find(x => x.CodigoCuenta == nroCuenta);

            if (tipoBorrado == "UNICO") {
                let tar = estadoPlastico.tarjetas.find(x => x.Numero == tarjetaActual.numero);
                if (tar !== undefined) {
                    let codigo;
                    if (c.Vinculo == 1)
                        codigo = '210001';
                    else
                        codigo = '210002';

                    _guardarSolicitud(codigo, tar.Numero, null, estadoPlastico, nroCuenta)
                }
            }
            else if (tipoBorrado == "MULTIPLE") {
                //Desmokear cuenta id... de tarjetaActual...
                let tarjetasToDelete = [];

                //Se recorre cada una de las tarjetas correspondientes a la cuenta, y se agrega al localValue para realizar la baja...
                for (var i = 0; i < estadoPlastico.tarjetas.length; i++) {
                    if (estadoPlastico.tarjetas[i].NumeroCuenta == nroCuenta) {
                        let localValues = _getLocalValuSolicitud(estadoPlastico);

                        let cuentaEstado = estadoPlastico.consultaCuenta.find(x => x.Cuenta == nroCuenta && x.Sucursal == c.Sucursal);

                        if (estadoPlastico.tarjetas[i].Vinculo == 1)
                            localValues.CODIGO_TRANSACCION = '210001';
                        else
                            localValues.CODIGO_TRANSACCION = '210002';

                        localValues.NUMERO_CUENTA = nroCuenta
                        localValues.NUMERO_TARJETA = estadoPlastico.tarjetas[i].Numero;
                        localValues.PRODUCTO = estadoPlastico.tarjetas[i].idProducto;
                        localValues.SUCURSAL_ID = estadoPlastico.tarjetas[i].SucursalId
                        localValues.CODIGO_LIMITE_DEBITO = estadoPlastico.tarjetas[i].CodigoLimite;
                        localValues.CODIGO_LIMITE_CREDITO = estadoPlastico.tarjetas[i].CodigoLimite;
                        if (c !== undefined) {
                            localValues.CODIGO_SISTEMA = parseInt(c.CodigoSistema);
                            localValues.CODIGO_MONEDA = parseInt(c.CodigoMoneda);
                            localValues.SUCURSAL_ID = parseInt(c.Sucursal);
                            localValues.VINCULO_ORIGINAL = c.Vinculo;
                        }
                        tarjetasToDelete.push(localValues);
                    }
                }

                let parameters = {
                    "tarjetas": tarjetasToDelete
                };

                //SagasProxy.AddSagaRequests(parameters, 'CrearSolicitud', "TARJETAS", "DELIVERY");
                //SagasProxy.Execute(_guardarSolicitudCallback, undefined, undefined, "DELIVERY");

                Engine1Proxy.AddRuleRequests(parameters, 'CrearSolicitud', 'Tarjetas', 'Delivery');
                Engine1Proxy.Execute(_guardarSolicitudCallback, null, null, "DELIVERY");
            }

        } else {

            let parametroDatosFiliatorios = {
                'DOCUMENTO': tarjetaActual.numeroDocumento
            }

            Engine1Proxy.AddRuleRequests(parametroDatosFiliatorios, 'GETCLIENTEDATOSFILIATORIOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');

            var ParametrosSolicitud = {
                codigo: 0,
                nroTarjeta: tarjetaActual.numero,
                valorModificacion: estadoPlastico,
                nroCuenta: nroCuenta,
                estadoPlasticoOriginal: estadoPlastico,
                tipoBorrado: tipoBorrado
            };
            Engine1Proxy.Execute((data) => _callBackLimitesDomicilio(data, ParametrosSolicitud), null, null, "CONSULTASOCIOS");

        }
        
    }

    //LogHelper.Out(borrarTarjeta.name, estadoPlastico, tarjetaActual, tipoBorrado);
}

/**
 * Crea una solicitud de reimpreci�n de tarjeta.
 * @param {any} tarjetaActual
 */
export function reimprimirTarjeta(tarjetaActual, estadoPlastico, nroCuenta) {
    //LogHelper.In(reimprimirTarjeta.name, tarjetaActual);
    return (dispatch, getState) => {
        _dispatch = dispatch;

        if (tarjetaActual.numeroDocumento == ValueCuil(estadoPlastico.clienteResultadoBusqueda.NumeroDocumento.toString()) ) {
            _guardarSolicitud('190000', tarjetaActual.numero, null, estadoPlastico, nroCuenta);

        } else {

            let parametroDatosFiliatorios = {
                'DOCUMENTO': tarjetaActual.numeroDocumento
            }

            Engine1Proxy.AddRuleRequests(parametroDatosFiliatorios, 'GETCLIENTEDATOSFILIATORIOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');

            var ParametrosSolicitud = {
                codigo: 190000,
                nroTarjeta: tarjetaActual.numero,
                valorModificacion: estadoPlastico,
                nroCuenta: nroCuenta,
                estadoPlasticoOriginal: estadoPlastico
            };
            Engine1Proxy.Execute((data) => _callBackLimitesDomicilio(data, ParametrosSolicitud), null, null, "CONSULTASOCIOS");

        }
    }

}

/**
 * Crea una solicitud de reimpreci�n de un pin asociado a la tarjeta.
 * @param {any} tarjetaActual
 */
export function reimprimirPin(tarjetaActual, estadoPlastico, nroCuenta) {
    //LogHelper.In(reimprimirTarjeta.name, tarjetaActual);
    return (dispatch, getState) => {
        _dispatch = dispatch;

        if (tarjetaActual.numeroDocumento == ValueCuil(estadoPlastico.clienteResultadoBusqueda.NumeroDocumento.toString())) {
            _guardarSolicitud('170000', tarjetaActual.numero, null, estadoPlastico, nroCuenta);
        } else {

            let parametroDatosFiliatorios = {
                'DOCUMENTO': tarjetaActual.numeroDocumento
            }

            Engine1Proxy.AddRuleRequests(parametroDatosFiliatorios, 'GETCLIENTEDATOSFILIATORIOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');

            var ParametrosSolicitud = {
                codigo: 170000,
                nroTarjeta: tarjetaActual.numero,
                valorModificacion: estadoPlastico,
                nroCuenta: nroCuenta,
                estadoPlasticoOriginal: estadoPlastico
            };
            Engine1Proxy.Execute((data) => _callBackLimitesDomicilio(data, ParametrosSolicitud), null, null, "CONSULTASOCIOS");
        }

    }
    //LogHelper.Out(reimprimirTarjeta.name, tarjetaActual);
}

/**
 * Permite modificar alguna solicitud existente o crear una nueva al realizar un cambio de domicilio y/o limite de alguna tarjeta.
 * @param {any} tipoModificacion
 */
export function modificarSolicitud(valorModificacion, estadoPlastico, tarjetaActual, nroCuenta) {
    //LogHelper.In(modificarSolicitud.name, tipoModificacion);
    return (dispatch, getState) => {
        _dispatch = dispatch;

        let tar = estadoPlastico.tarjetas.find(x => x.Numero == tarjetaActual.numero);
        let codigo;
        if (tar !== undefined) {
            if (tar.Vinculo == 1)
                codigo = '130001';
            else
                codigo = '130002';
        }

        if (tarjetaActual.numeroDocumento == ValueCuil(estadoPlastico.clienteResultadoBusqueda.NumeroDocumento.toString())) {
            _guardarSolicitud(codigo, tar.Numero, valorModificacion, estadoPlastico, nroCuenta, tar)

        } else {

            let parametroDatosFiliatorios = {
                'DOCUMENTO': tarjetaActual.numeroDocumento
            }

            Engine1Proxy.AddRuleRequests(parametroDatosFiliatorios, 'GETCLIENTEDATOSFILIATORIOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');

            var ParametrosSolicitud = {
                codigo: codigo,
                nroTarjeta: tar.Numero,
                valorModificacion: valorModificacion,
                nroCuenta: nroCuenta,
                estadoPlasticoOriginal: estadoPlastico,
                tar: tar
            };
            Engine1Proxy.Execute((data) => _callBackLimitesDomicilio(data, ParametrosSolicitud), null, null, "CONSULTASOCIOS");
        }
    }

    //LogHelper.Out(modificarSolicitud.name, tipoModificacion);
}


export function crearModificarSolicitudTarjeta(valorModificacion, estadoPlastico, tarjetaActual) {

}

/**
 * Elimina la o las solicitudes pendientes a enviar a Link.     
 * @param {any} idSolicitud
 */
export function deleteSolicitudPendiente(idSolicitud) {
    //LogHelper.In(deleteSolicitudPendiente.name, idSolicitud);
    return (dispatch, getState) => {
        _dispatch = dispatch;
        _idSolicitud = idSolicitud;

        let parameters = {
            "SOLICITUD_ID": idSolicitud !== undefined ? idSolicitud : null
        };

        Engine1Proxy.AddRuleRequests(parameters, 'BorrarSolicitudPendiente', 'Tarjetas', 'Delivery');
        Engine1Proxy.Execute(_deleteSolicitudPendienteCallback, null, null, "DELIVERY");

    }
    //LogHelper.Out(deleteSolicitudPendiente.name, idSolicitud);
}

/**
 * Permite visualizar un mensaje de Ok al finalizar algun proceso.
 * @param {any} trueFalse
 */
export function mostrarAlertaProcesoFinalizado(trueFalse) {
    //LogHelper.In(mostrarAlertaProcesoFinalizado.name, trueFalse);
    return (dispatch, getState) => {

        _dispatch({ type: 'ALERTA_PROCESO_FINALIZADO_CORRECTAMENTE', value: trueFalse });

    }
    //LogHelper.Out(mostrarAlertaProcesoFinalizado.name, trueFalse);
}

/**
 * Muestra los vinculos existentes.
 */
export function mostrarVinculos() {
    //LogHelper.In(mostrarVinculos.name);
    return (dispatch, getState) => {

        dispatch({ type: MOSTRAR_VINCULOS });

    }
    //LogHelper.Out(mostrarVinculos.name);
}

export function mostrarOcultarModalVinculos(seMuestra) {
    //LogHelper.In(mostrarOcultarModalVinculos.name);
    return (dispatch, getState) => {

        dispatch({ type: MOSTRAR_VINCULOS, seMuestra: seMuestra });

    }
    //LogHelper.Out(mostrarOcultarModalVinculos.name);
}

/**
 * Obtiene el historicos de movimientos que se realizaron sobre un plastico.
 * @param {any} nrotarjeta
 */
export function getHistorialMovimiento(nrotarjeta) {
    //LogHelper.In(getHistorialMovimiento.name, nrotarjeta);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        let parameters = {
            "NUMERO_TARJETA": nrotarjeta
        };

        Engine1Proxy.AddDataSourcesRequests(parameters, 'GET_HISTORIAL_MOVIMIENTOS_BY_NRO_TARJETA', 'Get', 'Tarjetas', 'Delivery', 1, 'Product');
        Engine1Proxy.Execute(_getHistorialMovimientoResult, null, null, "DELIVERY");
    }
    //LogHelper.Out(getHistorialMovimiento.name, nrotarjeta);
}

/**
 * Obtienen las solicitudes en cursos asociadas a un plastico.
 * @param {any} tarjetaId
 */
export function getSolicitudesTarjetaByTarjetaId(tarjetaId) {
    //LogHelper.In(getSolicitudesTarjetaByTarjetaId.name, tarjetaId);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        Engine1Proxy.AddDataSourcesRequests({ "PLASTICO_ID": tarjetaId.hasOwnProperty('id_plastico') ? tarjetaId.id_plastico : tarjetaId }, 'GET_SOLICITUDES_PLASTICO_BY_PLASTICO_ID', 'Get', 'Tarjetas', 'Delivery', 1, 'Product');
        Engine1Proxy.Execute(_getSolicitudesTarjetaByTarjetaIdResult, null, null, "DELIVERY");
    }
    //LogHelper.Out(getSolicitudesTarjetaByTarjetaId.name, tarjetaId);
}

/**
 * Retorna los vinculos entre cuentas, asociados a una determinada cuenta.
 * @param {any} tarjetaActual
 * @param {any} cuentas
 * @param {any} plasticos
 */
export function getVinculaciones(tarjetaActual, cuentas, plasticos) {
    //LogHelper.In(getVinculaciones.name, tarjetaActual);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        _dispatch({
            type: GET_VINCULACIONES,
            tarjetaActual: tarjetaActual,
            cuentas: cuentas,
            plasticos: plasticos
        });
    }
    //LogHelper.Out(getVinculaciones.name, tarjetaActual);
}

/**
 * Borra el vinculo pendiente con una cuenta.
 * @param {any} tarjetaActual
 * @param {any} cuentas
 * @param {any} plasticos
 */
export function borrarVinculo(cuenta) {
    //LogHelper.In(borrarVinculo.name, tarjetaActual);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        _dispatch({
            type: BORRAR_VINCULO,
            nroCuenta: cuenta.CodigoCuenta,
            NombreProducto: cuenta.NombreProducto
        });
    }
    //LogHelper.Out(borrarVinculo.name, tarjetaActual);
}
/* -------------------------------------------------------- FUNCIONES AUXILIARES -------------------------------------------------------- */

function _loadFuncionesUsuario(data) {
    //LogHelper.In(_loadFuncionesUsuario.name, data);

    if (data.DELIVERY)
        userFunctions = JSON.parse(JSON.stringify(data.DELIVERY)); //Permisos del usuario para la feature a utilizar.

    let funcionesUsuario = {};

    for (var i = 0; i < userFunctions.length; i++) {
        funcionesUsuario[userFunctions[i].Codigo_Funcion] = true;
    }

    _dispatch({ type: SET_FUNCIONES_DE_USUARIO, funciones: funcionesUsuario });

    /*Si tiene permisos sobre la consulta de la pantalla, hago el resto de las llamadas*/
    if (funcionesUsuario.Consulta) {
        _getCuentas();
    }

    //LogHelper.Out(_loadFuncionesUsuario.name, data);
}

function _getCuentas() {
    //LogHelper.In(_getCuentas.name);
    let parametrosIbsWs = {
        commandText: "DAMECONSULTACUENTACLIENTE",
        usrTipdoc: "88",
        usrIdent: "11111111",
        usrPassword: "frame7890*",
        encoding: "UTF8",
        sucursal: "14",
        procsdocod: "0",
        tipoDocumento: "8",
        numeroDocumento: _cliente.NumeroDocumento.toString(),
        codigoSistema: "5",
        codigoProducto: "0",
        numeroOperacion: "0"
    }

    Engine1Proxy.AddDataSourcesRequests(null, 'GET_SUCURSALES_DELIVERY', 'Get', 'Tarjetas', 'Delivery', 1, 'Product');
    Engine1Proxy.AddRuleRequests(parametrosIbsWs, 'GetCuetasIbs', 'Tarjetas', 'Delivery');
    Engine1Proxy.Execute(_getConsultaCuentas);
    //LogHelper.Out(_getCuentas.name);
}

function _getConsultaCuentas(data) {
    let cuentas = JSON.parse(data['GetCuetasIbs']);
    let consultaCuentas = []

    if (cuentas !== null) {
        for (let i = 0; i < cuentas.length; i++) {
            //Cargo los parametros para realizar la consulta de cuentas...
            consultaCuentas.push({
                usrTipdoc: "88",
                usrIdent: "11111111",
                usrPassword: "frame7890*",
                encoding: "UTF8",
                sucursal: cuentas[i].Sucursal,
                codigoSistema: "5",
                moneda: cuentas[i].CodigoMoneda,
                cuenta: cuentas[i].CodigoCuenta
            })
        }
    }

    let parametrosConsultaCuentas = {
        "cuentas": consultaCuentas
    };

    let callerId = {
        cuentas: cuentas,
        sucursales: JSON.parse(data['GET_SUCURSALES_DELIVERY']).Recordset0.Rows
    }

    Engine1Proxy.AddRuleRequests(parametrosConsultaCuentas, 'ConsultaCuentas', 'Tarjetas', 'Delivery');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_ESTADO_IBS', 'Get', 'Tarjetas', 'Delivery', 1, 'Product');
    Engine1Proxy.Execute(_loadSeleccionCuentas, null, callerId, null);
}

function _loadSeleccionCuentas(data) {
    //LogHelper.In(_loadSeleccionCuentas.name);
    let j = 0;
    let cuentas = data.CALLER_ID.cuentas;
    let consultaCuenta = JSON.parse(data.ConsultaCuentas);
    let estadosIbs = JSON.parse(data['GET_ESTADO_IBS']).Recordset0.Rows
    let callerId = { consultaCuenta: consultaCuenta, estadosIbs: estadosIbs }

    if (cuentas !== null) {
        for (let i = 0; i < cuentas.length; i++) {

            //Comienza verificacion si la cuenta esta activa o no...
            let cuentaEstado = consultaCuenta.find(x => x.Cuenta == cuentas[i].CodigoCuenta.toString() && x.Sucursal == cuentas[i].Sucursal);

            if (cuentaEstado !== undefined) {
                let estadoIbs = estadosIbs.find(x => x.estctacod == cuentaEstado.EstCtaCod);
                if (estadoIbs !== undefined && estadoIbs.Activo) {
                    //Fin Verificacion...

                    let parametrosPlasticos = {
                        'NRO_CUENTA': cuentas[i].CodigoCuenta
                    }

                    let parametrosSolicitud = {
                        'NRO_CUENTA': cuentas[i].CodigoCuenta,
                        'SUCURSAL': cuentas[i].Sucursal
                    }

                    Engine1Proxy.AddDataSourcesRequests(parametrosPlasticos, 'GET_TARJETAS_BY_NRO_CUENTA', 'Get', 'Tarjetas', 'Delivery', 1, 'Product', true, 'GET_TARJETAS_BY_NRO_CUENTA_' + j);
                    Engine1Proxy.AddDataSourcesRequests(parametrosSolicitud, 'GET_SOLICITUDES_BY_NRO_CUENTA', 'Get', 'Tarjetas', 'Delivery', 1, 'Product', true, 'GET_SOLICITUDES_BY_NRO_CUENTA_' + j);
                    j++
                }
            }
        }
    }

    const reducers = [];
    reducers.push(NuevaSolicitud);
    _dispatch({ type: 'STORE_INJECT', reducers: reducers });

    _dispatch({
        type: SET_CUENTA_DELIVERY,
        cuentas: cuentas,
        sucursales: data.CALLER_ID.sucursales
    });

    let parametrosSucursal = {
        USUARIO_ID: _userId
    }

    Engine1Proxy.AddDataSourcesRequests(parametrosSucursal, 'GET_SUCURSAL_BY_USUARIO_ID', 'Get', 'Concierge', 'Seguridad', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_ERROR_LINK', 'Get', 'Tarjetas', 'Delivery', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_ESTADO_IBS', 'Get', 'Tarjetas', 'Delivery', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_LIMITES_DEB_CRED', 'Get', 'Tarjetas', 'Delivery', 1, 'Product');

    Engine1Proxy.Execute(_loadSeleccionCuentasResultado, null, callerId, null);

    //LogHelper.Out(_loadSeleccionCuentas.name);
}

function _loadSeleccionCuentasResultado(data) {
    //LogHelper.In(_loadSeleccionCuentasResultado.name, data);

    let result = {
        tarjetasByNroCliente: [],
        solicitudesByNroCliente: [],
        sucursalUsuarioId: JSON.parse(data['GET_SUCURSAL_BY_USUARIO_ID']).Recordset0.Rows,
        consultaCuenta: data.CALLER_ID.consultaCuenta

    }

    let i = 0;
    while (data.hasOwnProperty('GET_TARJETAS_BY_NRO_CUENTA_' + i)) {
        let resultadoBusqueda = JSON.parse(data['GET_TARJETAS_BY_NRO_CUENTA_' + i]).Recordset0.Rows;
        if (resultadoBusqueda !== undefined)
            for (var j = 0; j < resultadoBusqueda.length; j++) {
                result.tarjetasByNroCliente.push(resultadoBusqueda[j]);
            }
        i++;
    }

    i = 0;
    while (data.hasOwnProperty('GET_SOLICITUDES_BY_NRO_CUENTA_' + i)) {
        let resultadoBusqueda = JSON.parse(data['GET_SOLICITUDES_BY_NRO_CUENTA_' + i]).Recordset0.Rows;
        if (resultadoBusqueda !== undefined)
            for (var j = 0; j < resultadoBusqueda.length; j++) {
                result.solicitudesByNroCliente.push(resultadoBusqueda[j]);
            }
        i++;
    }

    _dispatch({
        type: CARGAR_TARJETAS_BY_CUENTA,
        result: result,
        limites: JSON.parse(data['GET_LIMITES_DEB_CRED']).Recordset0.Rows,
        erroresLink: JSON.parse(data['GET_ERROR_LINK']).Recordset0.Rows,
        estadosIbs: data.CALLER_ID.estadosIbs,
    });

    let parameters = {
        "DOCUMENTO": _cliente.NumeroDocumento
    };

    let k = 0;
    for (var l = 0; l < result.solicitudesByNroCliente.length; l++) {
        let parametrosPlasticos = {
            'SOLICITUD_ID': result.solicitudesByNroCliente[l].Id
        }

        Engine1Proxy.AddDataSourcesRequests(parametrosPlasticos, 'GET_PLASTICO_SOLICITUD_BY_SOLICITUD_ID', 'Get', 'Tarjetas', 'Delivery', 1, 'Product', true, 'GET_PLASTICO_SOLICITUD_BY_SOLICITUD_ID_' + k);

        k++;

    }

    Engine1Proxy.AddRuleRequests(parameters, 'GetDomiciliosGeorge', 'Tarjetas', 'Delivery');
    Engine1Proxy.Execute(_GetDomiciliosGeorge, null, null, "DELIVERY");

    //LogHelper.Out(_loadSeleccionCuentasResultado.name, data);
}

function _GetDomiciliosGeorge(data) {
    //LogHelper.In(_GetDomiciliosGeorge.name, data);

    let wsDomicilioResult = JSON.parse(data.GetDomiciliosGeorge)
    let cliente = new Cliente(_cliente.Nombre + ' ' + _cliente.Apellido, _cliente.NumeroDocumento, 9974556, 'F');

    let plasticosSolicitudes = [];

    let i = 0;
    while (data.hasOwnProperty('GET_PLASTICO_SOLICITUD_BY_SOLICITUD_ID_' + i)) {
        let resultadoBusqueda = JSON.parse(data['GET_PLASTICO_SOLICITUD_BY_SOLICITUD_ID_' + i]).Recordset0.Rows;
        if (resultadoBusqueda !== undefined)
            for (var j = 0; j < resultadoBusqueda.length; j++) {
                plasticosSolicitudes.push(resultadoBusqueda[j]);
            }
        i++;
    }

    _dispatch({
        type: WEBSERVICE_RESULT,
        cliente: cliente
    });

    _dispatch({
        type: OBTENER_DOMICILIOS_SELECCIONAR_CUENTA,
        domicilios: wsDomicilioResult,
        plasticosSolicitudes: plasticosSolicitudes
    });

    //LogHelper.Out(_GetDomiciliosGeorge.name, data);
}

function _guardarSolicitudCallback(data) {
    if (data.CALLER_ID !== undefined && data.CALLER_ID.generaSolicitudPlastico) {
        let idSolicitud = data.CrearSolicitud;
        _generarSolicitudTarjeta(data.CALLER_ID.valorModificacion, data.CALLER_ID.tarjeta, idSolicitud);
    } else {
        _dispatch({ type: 'ALERTA_PROCESO_FINALIZADO_CORRECTAMENTE', value: true });
        _getCuentas();
    }
}

function _getLocalValuSolicitud(estadoPlastico) {

    let date = new Date();
    let nroDoc = estadoPlastico.clienteResultadoBusqueda.NumeroDocumento.toString();
    let estadoCivil = estadoPlastico.clienteResultadoBusqueda.EstadoCivil.Codigo.toString().substr(0, 1);
    return {
        SUCURSAL: "M",
        PRODUCTO: 1,
        NUMERO_CUENTA: 0,
        CALLE: forceNullIfUndefined(estadoPlastico.domicilios[1].CALLE),
        NUMERO: forceNullIfUndefined(estadoPlastico.domicilios[1].NUMERO_CALLE),
        PISO: forceNullIfUndefined(estadoPlastico.domicilios[1].PISO),
        DEPARTAMENTO: forceNullIfUndefined(estadoPlastico.domicilios[1].DEPTO),
        LOCALIDAD: forceNullIfUndefined(estadoPlastico.domicilios[1].LOCALIDAD),
        CODIGO_POSTAL: forceNullIfUndefined(estadoPlastico.domicilios[1].CODIGO_POSTAL),
        TELEFONO: forceNullIfUndefined(estadoPlastico.domicilios[1].TELEFONO),
        NUMERO_DOCUMENTO: forceNullIfUndefined(nroDoc),
        APELLIDO: forceNullIfUndefined(estadoPlastico.clienteResultadoBusqueda.Apellido),
        NOMBRE: forceNullIfUndefined(estadoPlastico.clienteResultadoBusqueda.Nombre),
        SEXO: forceNullIfUndefined(estadoPlastico.clienteResultadoBusqueda.Sexo),
        CODIGO: forceNullIfUndefined(estadoPlastico.clienteResultadoBusqueda.TipoDocumento.Id),
        DIGITO_VERIFICADOR: forceNullIfUndefined(nroDoc.substring(10, 11)),
        OCUPACION: "M",
        FECHA_NACIMIENTO: forceNullIfUndefined(estadoPlastico.clienteResultadoBusqueda.FechaNacimiento),
        ESTADO_CIVIL: forceNullIfUndefined(estadoPlastico.clienteResultadoBusqueda.EstadoCivil !== null ? estadoCivil : null),
        NACIONALIDAD: forceNullIfUndefined(estadoPlastico.clienteResultadoBusqueda.Nacionalidad !== null ? estadoPlastico.clienteResultadoBusqueda.Nacionalidad.Codigo : null),
        TIPO_DOCUMENTO: forceNullIfUndefined(estadoPlastico.clienteResultadoBusqueda.TipoDocumento.Codigo),
        CATEGORIA_CONSUMIDOR: "00",
        CODIGO_LIMITE_DEBITO: forceNullIfUndefined(estadoPlastico.clienteResultadoBusqueda.Limite),
        CODIGO_LIMITE_CREDITO: forceNullIfUndefined(estadoPlastico.clienteResultadoBusqueda.Limite),
        GRUPO_AFINIDAD: "M", //NO APLCA...
        TIPO_CUENTA: "M", //NO APLICA...
        LOGIN: _login,
        CODIGO_TRANSACCION: 1,
        NUMERO_TARJETA: "0000000000000000000",
        CODIGO_SISTEMA: 0,
        CODIGO_MONEDA: 0,
        SUCURSAL_ID: 0,
        NRO_ORIGINAL: null,
        VINCULO_ORIGINAL: 0
    };

}

function _callBackLimitesDomicilio(data, parametrosSolicitud) {

    var clienteDatosFiliatorios = JSON.parse(data.GETCLIENTEDATOSFILIATORIOS);

    let parametroLimites = {
        'CLIENTE_BANCO_NUMERO': clienteDatosFiliatorios.ClienteBancoNumero,
        'NUMERO_DOCUMENTO': clienteDatosFiliatorios.NumeroDocumento.toString(),
        'TIPO_DOCUMENTO_CODIGO': clienteDatosFiliatorios.TipoDocumento.Codigo,
        'ES_PERSONA_FISICA': clienteDatosFiliatorios.EsPersonaFisica
    }

    let parametroDomicilios = {
        'CLIENTE_BANCO_NUMERO': clienteDatosFiliatorios.ClienteBancoNumero,
        'NUMERO_DOCUMENTO': clienteDatosFiliatorios.NumeroDocumento.toString(),
        'TIPO_DOCUMENTO_CODIGO': clienteDatosFiliatorios.TipoDocumento.Codigo,
        'ES_PERSONA_FISICA': clienteDatosFiliatorios.EsPersonaFisica
    }

    let parametrosDomicilioGeorge = {
        'DOCUMENTO': clienteDatosFiliatorios.NumeroDocumento.toString()
    }

    //LogHelper.Out(_buscarPorDocumentoLimitesDomicilios.name, parametroLimites, 'GETCLIENTELIMITES', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');
    Engine1Proxy.AddRuleRequests(parametroLimites, 'GETCLIENTELIMITES', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');
    //LogHelper.Out(_buscarPorDocumentoLimitesDomicilios.name, parametroDomicilios, 'GETCLIENTEDOMICILIOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');
    //Engine1Proxy.AddRuleRequests(parametroDomicilios, 'GETCLIENTEDOMICILIOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');
    Engine1Proxy.AddRuleRequests(parametrosDomicilioGeorge, 'GetDomiciliosGeorge', 'Tarjetas', 'Delivery');
   
    Engine1Proxy.Execute((data) => _callBackReadLimitesDomicilios(data, parametrosSolicitud), null, clienteDatosFiliatorios, "CONSULTASOCIOS");

}

function _callBackReadLimitesDomicilios(data, parametrosSolicitud) {

    var clienteDatosFiliatorios = data.CALLER_ID;
    var limites = JSON.parse(data.GETCLIENTELIMITES);
    //var domicilios = JSON.parse(data.GETCLIENTEDOMICILIOS);
    var domiciliosGeorge = JSON.parse(data.GetDomiciliosGeorge);

    clienteDatosFiliatorios.Limite = limites.LimiteTotal;
    clienteDatosFiliatorios.LimiteAsignado = limites.LimiteAsignado;
    clienteDatosFiliatorios.LimitePorCuit = limites.LimitePorCuit;
    clienteDatosFiliatorios.LimiteSinAsignar = limites.LimiteSinAsignar;
    //clienteDatosFiliatorios.Domicilios = domicilios;

    domiciliosGeorge.unshift({ 'id': 5, 'descripcion': 'hola' });



    var estadoPlastico = {
        clienteResultadoBusqueda: clienteDatosFiliatorios,
        domicilios: domiciliosGeorge,
        cuentasDelivery: parametrosSolicitud.estadoPlasticoOriginal.cuentasDelivery,
        tarjetas: parametrosSolicitud.estadoPlasticoOriginal.tarjetas,
        tipoBorrado: parametrosSolicitud.tipoBorrado
    }


    _guardarSolicitud(parametrosSolicitud.codigo, parametrosSolicitud.nroTarjeta, parametrosSolicitud.valorModificacion, estadoPlastico, parametrosSolicitud.nroCuenta, parametrosSolicitud.tar);
    //_guardarSolicitud('190000', tarjetaActual.numero, null, estadoPlastico, nroCuenta);
}


function _guardarSolicitud(codigo, nroTarjeta, valorModificacion, estadoPlastico, nroCuenta, tarjeta) {
    //LogHelper.In(_guardarSolicitud.name);

    var tipoBorrado = estadoPlastico.tipoBorrado;

    if (tipoBorrado != undefined) {
        //var c = estadoPlastico.cuentasDelivery.find(x => x.CodigoCuenta == nroCuenta);
        let tar = estadoPlastico.tarjetas.find(x => x.Numero == nroTarjeta);

        if (tipoBorrado == "UNICO") {
            
            if (tar !== undefined) {
                let codigo;
                if (tar.Vinculo == 1)
                    codigo = '210001';
                else
                    codigo = '210002';

                estadoPlastico.tipoBorrado = undefined;
                _guardarSolicitud(codigo, tar.Numero, null, estadoPlastico, nroCuenta)
            }
        }
        else if (tipoBorrado == "MULTIPLE") {
            //Desmokear cuenta id... de tarjetaActual...
            let tarjetasToDelete = [];

            //Se recorre cada una de las tarjetas correspondientes a la cuenta, y se agrega al localValue para realizar la baja...
            for (var i = 0; i < estadoPlastico.tarjetas.length; i++) {
                if (estadoPlastico.tarjetas[i].NumeroCuenta == nroCuenta) {
                    let localValues = _getLocalValuSolicitud(estadoPlastico);

                    let cuentaEstado = estadoPlastico.consultaCuenta.find(x => x.Cuenta == nroCuenta && x.Sucursal == c.Sucursal);

                    if (estadoPlastico.tarjetas[i].Vinculo == 1)
                        localValues.CODIGO_TRANSACCION = '210001';
                    else
                        localValues.CODIGO_TRANSACCION = '210002';

                    localValues.NUMERO_CUENTA = nroCuenta
                    localValues.NUMERO_TARJETA = estadoPlastico.tarjetas[i].Numero;
                    localValues.PRODUCTO = estadoPlastico.tarjetas[i].idProducto;
                    localValues.SUCURSAL_ID = estadoPlastico.tarjetas[i].SucursalId
                    localValues.CODIGO_LIMITE_DEBITO = estadoPlastico.tarjetas[i].CodigoLimite;
                    localValues.CODIGO_LIMITE_CREDITO = estadoPlastico.tarjetas[i].CodigoLimite;
                    if (c !== undefined) {
                        localValues.CODIGO_SISTEMA = parseInt(c.CodigoSistema);
                        localValues.CODIGO_MONEDA = parseInt(c.CodigoMoneda);
                        localValues.SUCURSAL_ID = parseInt(c.Sucursal);
                        localValues.VINCULO_ORIGINAL = c.Vinculo;
                    }
                    tarjetasToDelete.push(localValues);
                }
            }

            let parameters = {
                "tarjetas": tarjetasToDelete
            };

            //SagasProxy.AddSagaRequests(parameters, 'CrearSolicitud', "TARJETAS", "DELIVERY");
            //SagasProxy.Execute(_guardarSolicitudCallback, undefined, undefined, "DELIVERY");

            Engine1Proxy.AddRuleRequests(parameters, 'CrearSolicitud', 'Tarjetas', 'Delivery');
            Engine1Proxy.Execute(_guardarSolicitudCallback, null, null, "DELIVERY");
        }



    } else {

        let callbackParameters = { generaSolicitudPlastico: false, tarjeta: tarjeta, valorModificacion: valorModificacion };
        let valoresGuardado = [];
        let localValues = _getLocalValuSolicitud(estadoPlastico);

        let plastico = estadoPlastico.tarjetas.find(x => x.Numero == nroTarjeta);

        let c = estadoPlastico.cuentasDelivery.find(x => x.CodigoCuenta == nroCuenta);

        if (codigo == 190000)
            localValues.NRO_ORIGINAL = nroTarjeta

        localValues.CODIGO_TRANSACCION = codigo;
        localValues.CODIGO_TRANSACCION = parseInt(localValues.CODIGO_TRANSACCION);
        localValues.NUMERO_TARJETA = nroTarjeta;
        localValues.NUMERO_CUENTA = nroCuenta !== undefined ? nroCuenta : null;
        localValues.PRODUCTO = plastico.idProducto;
        localValues.CODIGO_SISTEMA = parseInt(c.CodigoSistema);
        localValues.CODIGO_MONEDA = parseInt(c.CodigoMoneda);
        localValues.SUCURSAL_ID = parseInt(c.Sucursal);
        localValues.CODIGO_LIMITE_DEBITO = plastico.CodigoLimite !== undefined ? plastico.CodigoLimite : null;
        localValues.CODIGO_LIMITE_CREDITO = plastico.CodigoLimite !== undefined ? plastico.CodigoLimite : null;
        localValues.VINCULO_ORIGINAL = c.Vinculo;

        if (valorModificacion !== undefined && valorModificacion !== null) {
            switch (valorModificacion.type) {

                case 'DOMICILIO':
                    localValues.CODIGO_LIMITE_DEBITO = "";
                    localValues.CALLE = valorModificacion.value.CALLE !== undefined ? valorModificacion.value.CALLE : null;
                    localValues.NUMERO = valorModificacion.value.NUMERO_CALLE !== undefined ? valorModificacion.value.NUMERO_CALLE : null;
                    localValues.PISO = valorModificacion.value.PISO !== undefined ? valorModificacion.value.PISO : null;
                    localValues.DEPARTAMENTO = valorModificacion.value.DEPTO !== undefined ? valorModificacion.value.DEPTO : null;
                    localValues.LOCALIDAD = valorModificacion.value.LOCALIDAD !== undefined ? valorModificacion.value.LOCALIDAD : null;
                    localValues.CODIGO_POSTAL = valorModificacion.value.CODIGO_POSTAL !== undefined ? valorModificacion.value.CODIGO_POSTAL : null;
                    callbackParameters.generaSolicitudPlastico = true;

                    break;

                case 'LIMITE':
                    localValues.CODIGO_LIMITE_DEBITO = valorModificacion.value;
                    localValues.CODIGO_LIMITE_CREDITO = valorModificacion.value;
                    callbackParameters.generaSolicitudPlastico = true;
                    break;
            }
        }

        valoresGuardado.push(localValues);

        let parameters = {
            "tarjetas": valoresGuardado
        };

        Engine1Proxy.AddRuleRequests(parameters, 'CrearSolicitud', 'Tarjetas', 'Delivery');
        Engine1Proxy.Execute(_guardarSolicitudCallback, null, callbackParameters, "DELIVERY");

    }
    //LogHelper.Out(_guardarSolicitud.name);
}

function _deleteSolicitudPendienteCallback(data) {
    //LogHelper.In(_deleteSolicitudPendienteCallback.name);

    _dispatch({
        type: BORRAR_SOLICITUD_PENDIENTE_CUENTAS,
        idSolicitud: _idSolicitud
    });

    _getCuentas();

    //LogHelper.Out(_deleteSolicitudPendienteCallback.name);
}

function _getVinculosByNroTarjetaResult(data) {
    //LogHelper.In(_getVinculosByNroTarjetaResult.name);

    _dispatch({
        type: VINCULOSS_BY_NUMERO_CUENTA,
        vinculos: JSON.parse(data['GET_VINCULOS_CUENTA_BY_NRO_TARJETA']).Recordset0.Rows
    });

    //LogHelper.Out(_getVinculosByNroTarjetaResult.name);
}

function _getHistorialMovimientoResult(data) {
    //LogHelper.In(_getHistorialMovimientoResult.name);

    _dispatch({
        type: HISTORIAL_MOVIMIENTOS_TARJETA,
        delivery: JSON.parse(data['GET_HISTORIAL_MOVIMIENTOS_BY_NRO_TARJETA']).Recordset0.Rows,
        solicitud: JSON.parse(data['GET_HISTORIAL_MOVIMIENTOS_BY_NRO_TARJETA']).Recordset1.Rows
    });

    //LogHelper.Out(_getHistorialMovimientoResult.name);
}

function _getSolicitudesTarjetaByTarjetaIdResult(data) {
    //LogHelper.In(_getSolicitudesTarjetaByTarjetaIdResult.name);

    _dispatch({
        type: GET_SOLICITUDES_PLASTICO_BY_PLASTICO_ID,
        solicitudesPlasticos: JSON.parse(data['GET_SOLICITUDES_PLASTICO_BY_PLASTICO_ID']).Recordset0.Rows
    });

    //LogHelper.Out(_getSolicitudesTarjetaByTarjetaIdResult.name);
}

function _guardarSolicitudVinculacionCallback(data) {
    //LogHelper.In(_guardarSolicitudVinculacionCallback.name);

    let idSOlicitud = data.CrearSolicitudVinculoCuentas;
    let infoCuentas = data.CALLER_ID.infoCuentas;

    for (var i = 0; i < infoCuentas.length; i++) {
        infoCuentas[i].SOLICITUD_ID = parseInt(idSOlicitud);
    }

    let parameters = {
        "infoCuentas": infoCuentas
    };

    Engine1Proxy.AddRuleRequests(parameters, 'CrearModificarVinculacionCuenta', 'Tarjetas', 'Delivery');
    Engine1Proxy.Execute(_finalizarGuardadoVinculacion, null, null, "DELIVERY");

    //LogHelper.Out(_guardarSolicitudVinculacionCallback.name);
}

function _finalizarGuardadoVinculacion(data) {
    _dispatch({ type: MOSTRAR_VINCULOS, seMuestra: false });
    _dispatch({ type: ERROR_VINCULACION, esError: 0 });
    GetVinculosByNroTarjeta(_nroTarjeta);
}

function _generarSolicitudTarjeta(valorModificacion, tarjeta, idSolicitud) {

    let parametros = {
        PLASTICO_ID: tarjeta.id_plastico,
        DOMICILIO: null,
        PRODUCTO_ID: tarjeta.id_tipo_tarjeta == undefined ? null : tarjeta.id_tipo_tarjeta,
        CODIGO_LIMITE_ID: null,
    }

    if (valorModificacion.type == 'LIMITE') {
        parametros.CODIGO_LIMITE_ID = valorModificacion.value;
    }
    else {
        let direccion = valorModificacion.value.CALLE + " " + valorModificacion.value.NUMERO_CALLE + ", " + valorModificacion.value.DESC_PROVINCIA + ", " + valorModificacion.value.CODIGO_POSTAL + " (" + valorModificacion.value.DESC_TIPO_DOMIC + ")";
        parametros.DOMICILIO = direccion; parametros.LOGIN = valorModificacion.login;
    }

    parametros.SOLICITUD_ID = idSolicitud

    Engine1Proxy.AddRuleRequests(parametros, 'CrearModificarSolicitudPlasticos', 'Tarjetas', 'Delivery');
    Engine1Proxy.Execute(_generarSolicitudTarjetaCallback, null, null, "DELIVERY");
}

function _generarSolicitudTarjetaCallback(data) {
    _dispatch({ type: 'ALERTA_PROCESO_FINALIZADO_CORRECTAMENTE', value: true });
    _getCuentas();
}

function forceNullIfUndefined(value) {
    return value == undefined ? null : value;
}
function ValueCuil(value) {

    if (value.length == 11) {
        value = value.slice(2, -1);
    }
    return value;
}